import { render, staticRenderFns } from "./distribuicao.vue?vue&type=template&id=ecf43a96&"
import script from "./distribuicao.vue?vue&type=script&lang=js&"
export * from "./distribuicao.vue?vue&type=script&lang=js&"
import style0 from "./distribuicao.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecf43a96')) {
      api.createRecord('ecf43a96', component.options)
    } else {
      api.reload('ecf43a96', component.options)
    }
    module.hot.accept("./distribuicao.vue?vue&type=template&id=ecf43a96&", function () {
      api.rerender('ecf43a96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/distribuicao/distribuicao.vue"
export default component.exports